module.exports = __webpack_public_path__ + "static/media/meistre.990f129d.m4a";